import AIAutoSetupPage from "./AIAutoSetupPage";
import QuickAutomationSetup from "./QuickAutomationSetup";
import React from "react";
import AiStickerGenerator from "./AiStickerGenerator";


const InitializeSetup = () => {

    return (
        <>
            <QuickAutomationSetup />
            <AIAutoSetupPage />
            <AiStickerGenerator />
        </>
    )
}

export default InitializeSetup